import React from "react";
import AppConstants from "../../../constants/AppConstants";
import PagesPanel from "./PagesPanel/PagesPanel";
import LayersPanel from "../LayersPanel/LayersPanel";
import SiteDesignStore from "../../../stores/SiteDesignStore";
import { useSiteState } from "../../../hooks/query/useSite";
import useStoreState from "../../providers/useStoreState";
import SitePanelTabset from "../../../app2components/panel/SitePanelTabset";
import styles from "./SitePanel.module.css";

const { PANEL_LAYERS, PANEL_PAGES } = AppConstants;

const SitePanel = ({ viewState, blockContainer, stageView }) => {
  const site = useSiteState();
  const pages = useStoreState(SiteDesignStore, SiteDesignStore.getFullPageList);
  const siteBlocks = useStoreState(SiteDesignStore, SiteDesignStore.getSiteBlockList);
  const canvasSets = useStoreState(SiteDesignStore, SiteDesignStore.getCanvasSetList);
  const activePanel = viewState.get("activePanel");

  const view =
    activePanel === PANEL_PAGES ? (
      <PagesPanel
        stageView={stageView}
        pages={pages}
        site={site}
        siteBlocks={siteBlocks}
        canvasSets={canvasSets}
        blockContainer={blockContainer}
      />
    ) : activePanel === PANEL_LAYERS ? (
      <LayersPanel
        stageView={stageView}
        pages={pages}
        canvasSets={canvasSets}
        siteBlocks={siteBlocks}
        blockContainer={blockContainer}
      />
    ) : null;

  return (
    <div className={styles.root}>
      <SitePanelTabset activeTab={activePanel} blockContainer={blockContainer} />
      {view}
    </div>
  );
};

export default SitePanel;
